import React from "react";
import { Dialog, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const ResponsiveDialog = ({ children, ...props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog fullScreen={fullScreen} {...props}>
      {children}
    </Dialog>
  );
};

export default ResponsiveDialog;
